import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import * as serviceWorker from './serviceWorker.ts';
const authentication = require('./react-azure-adb2c2').default;



authentication.initialize({

      // optional, will default to this
  
      instance: 'https://homestation.b2clogin.com/',
  
      // instance: 'https://homestation.b2clogin.com/tfp/',
  
  
  
  
  
      // your B2C tenant
  
      tenant: 'homestation.onmicrosoft.com',
  
      // the policy to use to sign in, can also be a sign up or sign in policy
  
      // signInPolicy: 'B2C_1_homestationsignin',
  
      signInPolicy: 'B2C_1_homestation_signin',
  
      // the the B2C application you want to authenticate with
  
      applicationId: 'ac11df9b-6841-40e7-9ea0-fce289a3fed0',
  
      // where MSAL will store state - localStorage or sessionStorage
  
      // cacheLocation: 'sessionStorage',
  
      cacheLocation: 'localStorage',
  
      // the scopes you want included in the access token
  
      scopes: ['https://homestation.onmicrosoft.com/api/user_impersonation'],
  
      //redirectUri: 'https://localhost:44339/',
  
      redirectUri: process.env.REACT_APP_BASE_URL,
  
      // redirectUri: 'http://localhost:37158/',    
  
      // redirectUri: 'https://homestationreact.azurewebsites.net',
  
  
  
  
      // optional, the URI to redirect to after logout
  
      //postLogoutRedirectUri: 'https://homestationreact.azurewebsites.net'
  
  });
// const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(
  authentication.run(() => {
        ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
        <App />
    </BrowserRouter>
    
  </React.StrictMode>
);serviceWorker.unregister();
    })

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
